import { Subject } from "rxjs";
import axios from "./axios.service";
import config from "../_helpers/app.constants";
import { ILoggedInUser } from "app/reducers/loginUserSlice";
import { headers } from "app/_helpers";
import OAuth2Service from "app/services/OAuth2.service";

const currentUserSubject = new Subject();
const VENUE_ID_KEY = "defaultSelectedVenueId";
const authenticationService = {
  login: () => {
    const params = new URLSearchParams(window.location.search);
    var token = params.get("token");
    if (token) {
      // TODO: Validate token is correct - Send API request Backend - and also do a GET Me() info for account details.
      localStorage.setItem("token", token);
    }
    var venueId = Number(params.get("venueId"));
    if (venueId > 0) {
      localStorage.setItem(VENUE_ID_KEY, `${venueId}`);
    }
  },
  OAuth2Login: (rest: any) => {
    const params = new URLSearchParams(window.location.search);
    const venueId = params.get("venueId") || localStorage.getItem(VENUE_ID_KEY);
    if (venueId) {
      localStorage.setItem(VENUE_ID_KEY, `${venueId}`);
      const state = `venueId=${venueId}`;
      OAuth2Service.login(false, state);
    } else {
      authenticationService.logout();
    }
  },
  getAccountInfo: async (): Promise<ILoggedInUser> => {
    const token = config.enableOAuth2
      ? OAuth2Service.getOAuth2AccessToken()
      : localStorage.getItem("token");
    const reqConfig = {
      headers: {
        ...headers.defaultHeaders(),
        Authorization: `Bearer ${token}`,
      },
    };
    try {
      const result = await axios.get<ILoggedInUser>(
        `${config.backendApiUrl}/me`,
        reqConfig
      );

      localStorage.setItem("account", JSON.stringify(result.data));
      currentUserSubject.next(result.data);
      return result.data;
    } catch (error) {
      console.warn(error);
      localStorage.removeItem("account");
    }
    return null;
  },
  logout: () => {
    if (localStorage.getItem("token")) {
      localStorage.removeItem("token");
    }
    if (localStorage.getItem("account")) {
      localStorage.removeItem("account");
      currentUserSubject.next(null);
    }
    localStorage.removeItem("selectVenue");
    OAuth2Service.logout();
    OAuth2Service.deleteCookies();
    OAuth2Service.removeStoredDataForOauth();
  },
  currentUser: currentUserSubject.asObservable(),
  get currentUserValue() {
    return this.currentUserSubject.value;
  },
};

export default authenticationService;
